import { render, staticRenderFns } from "./SmartFollowup.vue?vue&type=template&id=e814677a&"
import script from "./SmartFollowup.vue?vue&type=script&lang=js&"
export * from "./SmartFollowup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports